import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
  AnalyticService,
  ApiAnalyticReportCriterionFacilityGetRequestParams,
  ApiAnalyticReportGeneralGetRequestParams
} from '../../../apiModule1';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIcon} from '@angular/material/icon';
import {MatInput, MatPrefix} from '@angular/material/input';
import {TableComponent} from '../../../../shared/components/table/table.component';
import {BehaviorSubject} from 'rxjs';
import {ITableColumn} from '../../../../core/common/interfaces/table-column.interface';
import {TableCellDirective} from '../../../../shared/components/table/table-cell.directive';
import {DataTableService} from '../../../../core/services/data-table.service';
import {
  analyticTableToData,
  LegendInterface,
  replaceIdToOrder,
  TransformedObject
} from '../report-property-mod.component';
import {TableServiceService} from '../../report-general/table-service.service';
import {CELL_NAME, cellSort, columnSort, TableData} from "../../report-general/report-general.component";

@Component({
  selector: 'pas-details',
  standalone: true,
  imports: [
    FormsModule,
    MatIcon,
    MatInput,
    MatPrefix,
    ReactiveFormsModule,
    TableComponent,
    TableCellDirective,
  ],
  providers: [{provide: DataTableService, useClass: TableServiceService}],
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsComponent implements OnInit {
  el = inject(ElementRef);
  data: {
    element: AnalyticTableRow,
    legends: TransformedObject<LegendInterface>,
    filter: ApiAnalyticReportGeneralGetRequestParams
  } = inject(MAT_DIALOG_DATA);
  analyticsService = inject(AnalyticService);
  private dataTableService = inject(DataTableService);
  cdr = inject(ChangeDetectorRef);
  dialogRef = inject(MatDialogRef<DetailsComponent>)

  gotData: AnalyticTableRow[] = [];

  search = new FormControl<string>('');

  updateList = new BehaviorSubject<void>(undefined);

  private rawData: any | null = null;

  get tableData(): any[] | undefined {
    const res = this.dataTableService.getData() as unknown as { pager: unknown, values: any[] };
    return res?.values;
  }

  setTableDate(table: AnalyticTableRow[]): void {
    // const tableData = analyticTableToData(table);
    // console.log('tableData', tableData);
    // const columnsData: ITableColumn[] = analyticTableToColumns(tableData.values);
    // console.log('columnsData', columnsData);
    // this.dataTableService.setColumns(columnsData);
    // const convertedTableData = replaceIdToOrder(tableData.values as { id: number; }[])
    // this.dataTableService.setData({pager: {}, values: convertedTableData});
    // this.rawData = convertedTableData;
    // this.cdr.detectChanges();
    const tableData = analyticTableToData(table);
    console.log('tableData', tableData);
    const columnsData: ITableColumn[] = analyticTableToColumns(replaceIdToOrder(tableData.values as { id: number; }[]));
    console.log('columnsData', columnsData);
    this.dataTableService.setColumns(columnsData);
    const convertedTableData = replaceIdToOrder(tableData.values as { id: number; }[])
    this.dataTableService.setData({pager: {}, values: convertedTableData});
    this.rawData = convertedTableData;
    this.cdr.markForCheck();
  }

  ngOnInit(): void {
    console.log('data', this.data);
    console.log('el', this.el.nativeElement);
    this.dataTableService.showCustomColumns = false;
    this.setTableDate([]);
    const params: ApiAnalyticReportCriterionFacilityGetRequestParams = {
      organizationId: this.data.element.id,
      year: this.data.filter.year,
      quarter: this.data.filter.quarter,
      periodId: this.data.filter.periodId,
    }
    this.analyticsService.apiAnalyticReportCriterionFacilityGet(params)
      .subscribe(({table}: { table: AnalyticTableRow[] }) => {
        console.log('table', table);
        this.gotData = table;
        this.setTableDate(table);
        this.cdr.detectChanges();
      });

    this.search.valueChanges.subscribe((term: string | null) => {
      if (!this.gotData) return;
      if (!term) return this.setTableDate(this.gotData);
      const data: any[] | undefined = this.tableData;
      const res = this.gotData.filter((item: any) => JSON.stringify(item).toLowerCase().includes(term.toLowerCase()));
      this.setTableDate(res);
    })

  }

  close(): void {
    this.dialogRef.close();
  }

  private _setTableData(data: TableData[]): void {
    this.dataTableService.setData({pager: {}, values: data});
    this.cdr.markForCheck();
  }

  onSortedColumn($event: any): void {
    console.log('sortedColumn', $event);
    console.log('table', this.dataTableService.getData())
    const tableData: TableData[] = this.dataTableService.getData().values;

    const reverseDirect = $event.direction === 'desc' ? 'asc' : ($event.direction === '' ? '' : 'desc');

    if ($event.direction === '') {
      return this._setTableData(this.rawData)
    }

    if ($event.active.startsWith(CELL_NAME)) {
      this._setTableData(
        replaceIdToOrder(cellSort($event.active, reverseDirect, tableData), $event.direction)
      )
    } else {
      this._setTableData(
        replaceIdToOrder(columnSort($event.active, reverseDirect, tableData), $event.direction)
      )
    }
  }

  protected readonly Math = Math;
}

function analyticTableToColumns(value: unknown[]): ITableColumn[] {
  if (!value || !value.length) return [];
  const entries = Object.entries(value[0] as any)
    .filter(([_, value]) => value !== null && value !== undefined);
  const res: ITableColumn[] = entries.map(([key, value]): ITableColumn|boolean => {
    const name = (value as any)?.name;
    let title = key.startsWith('cell') ? name : key;
    if (title === 'name') {
      title = 'Объект'
    }
    if (title === 'uid') {
      title = '№'
    }
    if (title === 'address') {return false}
    if(title === 'id') {return false}
    return {
      name: key,
      title,
      default: true,
      useCustomTemplate: key !== 'uid',
      maxWidth: key === 'name' ? '200px' : '0px',
    }
  }).filter(Boolean) as ITableColumn[];
  const lastElement: ITableColumn = res.pop() as ITableColumn;
  res.unshift(lastElement)
  return res;
};
